<template>
  <div id="solution">
      <div id="puzzle-title">{{ puzzle.name }}</div>
      <div id="puzzle-answer">Answer: <b>{{ puzzle.ans.toUpperCase() }}</b></div>
      <component :is="puzzleSolution" :key="'soln-'+puzzle.num"></component>
      <!-- <puzzle-content></puzzle-content> -->

  </div>
</template>

<script>
export default {
  name: 'Puzzle',
  props: ['id'],
  computed: {
    // can remove this later, no need to get all puzzles 
    puzzles () {
      return this.$store.state.puzzles
    },
    puzzle () {
      return this.puzzles.find(p => p.id == this.id)
    },
    puzzleSolution (ctx) {
      ctx.puzzle.id // need this line for some reason to reload
      return () => import('@/views/solutions/' + ctx.puzzle.id + '.vue')
    }
  },

} 
</script>

<style scoped>

  #puzzle-title{
    padding-top: 20px;
    text-align: center;
    font-size: 26pt;
  }

  #puzzle-answer{
    padding: 5px;
    text-align: center;
    font-size: 16pt;
    font-style: italic;
    width: 80%;
    margin: 0 auto;
  }

  #puzzle-solution {
    text-align: left;
    /*border: 5px solid grey;*/
  }

  #puzzle-solution >>> img {
    max-width: 100%;
    /* max-height: 100%; */
    /* object-fit: contain;	 */
  }
</style>